const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";

//Import Designs
import { Typography, Grid2 } from '@mui/material';

class RemainingBuyVotes extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { t } = this.props;
        const buy_votes_count = this.props.values?.buy_votes_count;

        return (
            <Grid2 className="wpvc_total_term_vote_count" >
                <Typography variant="body1" className="timer_typography">{t('remaining_buy_votes')} {buy_votes_count ? buy_votes_count : 0}</Typography>
            </Grid2>
        )
    }
}

export default (withTranslation("translations")(RemainingBuyVotes));
